export default __webpack_public_path__ + "static/media/Myloc-logga.e7d449c7.svg";